module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/CatPercent-0660ab0c68f92df2e0e3e9fae453d58f.png";